<template>
  <div class="categories-310">
    <div class="row justify-content-center" v-if="getCategories != null">
      <div class="mb-4" :class="itemClass" v-for="category in categoryShape(getCategories,categoryLinkProp)" :key="category.id">
        <m-category-card309 :category="category"/>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import mIcon from "../../Icons/Icon";
import mCategoryCard309 from "../../Category/Card/CategoryCard309";
import {categoryMethods} from "../CategoriesMethods";
/* todo implement with wrapper  */

export default {
  name: "Categories310",
  components: {mIcon, mCategoryCard309},
  props: {
    slicer: {
      default: Infinity
    },
    itemClass: {
      default: 'col-lg-4 col-md-6 col-sm-12'
    },
    categoryLinkProp: {
      default: 'product'
    },
    flatCategoriesShape: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapGetters({
      categories: "Category/getCategories",
    }),
    getCategories() {
      if (this.slicer) {
        return this.categories.slice(0, this.slicer)
      } else {
        return this.categories
      }
    },
  },
  methods: {
    ...categoryMethods,
  },
  async mounted() {
    await this.$store.dispatch("Category/getCategories")
  }
}
</script>

<style scoped>
.categories-310 .img-object-fit {
  object-fit: cover;
}

.categories-310-image {
  width: 100%;
}
</style>